import { getLabel } from "../../../../../hooks/use-labels";
import { getStyle } from "../../../../../hooks/use-styles";
import {
  calculateDiscount,
  formatCurrency,
} from "../../../../../utils/common-utils";

const PriceView = ({ amount, originalAmount }) => {
  const { value: originalValue } = originalAmount;
  const { value, currency } = amount;

  const discount =
    value !== originalValue
      ? calculateDiscount(value, originalValue, currency)
      : -1;

  const hasDiscount = discount > 0;


  return (
    <div
      className="product-price-container"
      style={{ color: getStyle("black") }}
    >
      <div className="font-20-bold-500 product-detail-price-label">{getLabel("priceLabel")}</div>
      <div className="font-20-bold-500 product-detail-price-value">
        <div className="text-right">{`${formatCurrency(+value, currency)}/-`}</div>
        
        {hasDiscount && (
          <div className="product-detail-discount">
             <span
              style={{ color: getStyle("primaryPink") }}
              className="product-detail-discount-label font-14-bold-500-lh-18"
            >
              {discount}% Discount
            </span>
            <span
              className="strike-through font-14-normal-400-lh-18"
              style={{ color: getStyle("secondaryGray") }}
            >
              {formatCurrency(originalValue,currency)}
            </span>
           
          </div>
        )}
        
      </div>
    </div>
  );
};

export default PriceView;
